import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { NoDataToDisplay } from "react-highcharts-no-data-to-display";
//import DonutChart from "react-donut-chart";
//import { PieChart as DonutChart} from 'react-minimal-pie-chart';

import Title from "../Wrappers/Title";


import { Grid, Divider, Typography } from "@material-ui/core";
NoDataToDisplay(Highcharts);

function StatusBar(data) {
	let callHandlingTime = 0;
	let talkTime = 0;
	let holdTime = 0;
	let wrapTime = 0;

	data.map((data) => {
		if (data.name === "Call Handling Time" || data.name === "Talk Time" || data.name === "Hold Time" || data.name === "Wrap Time") {
			let time = data.value.split(":");
			let timeVal = parseInt(time[2]) + parseInt(time[1]) * 60 + parseInt(time[0]) * 3600;
			if (data.name === "Call Handling Time") {
				callHandlingTime = timeVal;
			} else if (data.name === "Talk Time") {
				talkTime = timeVal;
			} else if (data.name === "Hold Time") {
				holdTime = timeVal;
			} else if (data.name === "Wrap Time") {
				wrapTime = timeVal;
			}
		}
		return true;
	});

	const chartData = [
		{ name: "Handling Time", y: callHandlingTime,custom:{extraInformation: convertSeconds(callHandlingTime)}},
		{ name: "Talk Time", y: talkTime,custom:{extraInformation: convertSeconds(talkTime)} },
		{ name: "Hold Time", y: holdTime,custom:{extraInformation: convertSeconds(holdTime)} },
		{ name: "Wrap Time", y: wrapTime,custom:{extraInformation: convertSeconds(wrapTime)}},
	];
	return chartData;
}
function convertSeconds(seconds) {
    var convert = function(x) { return (x < 10) ? "0"+x : x; }
    return convert(parseInt(seconds / (60*60))) + ":" +
           convert(parseInt(seconds / 60 % 60)) + ":" +
           convert(seconds % 60)
  }
  const options = {
    chart: {
        type: "pie",
        height:"200",
        width:"350"
      },
      legend: {
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        labelFormatter: function() {
            return this.name +"<br/><b>" + convertSeconds(this.y)+"</b>";
        },
        itemStyle: {
            color: '#686d88',
            fontSize:'12',
            fontWeight: 'light',
        }
    },
      plotOptions: {
        pie: {
          showInLegend: true,
          innerSize: "60%",
          dataLabels: {
            enabled: false,
            distance: 0,
            color: "white",
          }
        }
        
      },
      colors:["#ff6347", "#536DFE", "#FFC260", "#A0A0A0"],
    title: {
      text: ''
    },
    series:[{  // Boost when there are more than 1
    // point in the series.
        data: [ [0, 1], [1, 2], [2, 3] ]
    }], 
    tooltip: {
        headerFormat: '<b>{point.key}</b><br/>',
        pointFormat: '{point.custom.extraInformation}'
    },
    credits: {
        enabled: false
    },
  }
function ShowCallStatistics(props) {
	options.series=[{data:StatusBar(props.posts)}];
	
	return (
		<React.Fragment>
			<Title>Call Statistics</Title>
			<Divider />
			<Grid container spacing={2} style={{ marginTop: "15px" }}>
				<Grid item xs={12}>
                    {(parseInt(props.posts[0].value)>0)?(<HighchartsReact  highcharts={Highcharts} series={[{data:StatusBar(props.posts)}]} options={options} />):(<Typography variant="h5" align="center" style={{marginTop:"60px"}}>No Data Found</Typography>)}
                </Grid>
			</Grid>
		</React.Fragment>
	);
}

export default ShowCallStatistics;
